import React from 'react';
import { createStitches } from '@stitches/react'

export const { styled, css } = createStitches({
  prefix: '',
//   tokens: {},
//   breakpoints: {},
  utils: {}
})
